import { Layout, Spin } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { logout as authLogout } from "auth";
import MobileHeader from "components/Mobile/MobileHeader/MobileHeader";
import MobileFooter from "components/Mobile/MobileFooter/MobileFooter";
import useAuthStore from "stores/useAuthStore";
import "./MobileAppLayout.css";

const { Content } = Layout;

export default function MobileAppLayout({ children }) {
  const userData = useAuthStore((s) => s.userData);
  const documentTitle = useAuthStore((s) => s.documentTitle);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = documentTitle;
  }, [documentTitle]);

  const logout = () => {
    const { redirectPath } = authLogout();
    navigate(redirectPath);
  };

  if (!userData) {
    return <p>Loading user data...</p>;
  }

  return (
    <Layout className="mobile-app-layout">
      <MobileHeader onLogout={logout} />

      <Content className="mobile-app-layout-content">
        <div className="module-container mobile-app-page-content">{children}</div>
      </Content>

      <MobileFooter />
    </Layout>
  );
}
